import { createClient, type PostgrestSingleResponse } from '@supabase/supabase-js';
import type { Database } from '@farmos/shared/db';
import { env } from './env';

export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
  // the QR login link lands here with the session in the URL
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export type Tables<T extends keyof Database['public']['Tables']> =
  Database['public']['Tables'][T]['Row'];

type SupaError = { message: string; code?: string };

/** Throws Supabase errors for TanStack Query; `.maybeSingle()` results stay nullable. */
export function unwrap<T>(res: PostgrestSingleResponse<T>): T;
export function unwrap<T>(res: { data: T; error: SupaError | null }): T;
export function unwrap<T>(res: { data: T; error: SupaError | null }): T {
  if (res.error) throw Object.assign(new Error(res.error.message), { code: res.error.code });
  return res.data;
}
